import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { IdGen, Flex, Label, TextInput, Selector, ButtonGroup, ToggleButton } from '@leverege/ui-elements';
import Model from "./FontModel.js";
import Fonts from "./Fonts.js";
import S from './FontEditor.css';
export default function FontEditor(props) {
  const {
    value
  } = props;
  const onValueChange = useValueChange(Model, props);
  // const style = Model.getStyle( value )
  // const onStyle = ( e ) => {
  //   onValueChange( { data : 'setStyle', value : e.data } )
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: S.editor
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "rowS",
    align: "center",
    className: S.family
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "input"
  }, "Family"), /*#__PURE__*/React.createElement(Flex.Layout, {
    grow: 1
  }, /*#__PURE__*/React.createElement(Selector, {
    value: Model.getFamily(value),
    values: Fonts.getFamiliesAsOptions(),
    eventData: "setFamily",
    onChange: onValueChange
  }))), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowS",
    align: "center",
    justify: "flex-end",
    className: S.size
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "input",
    className: S.padLeft
  }, "Size"), /*#__PURE__*/React.createElement(TextInput, {
    size: 6,
    eventData: "setSize",
    hint: "Size",
    value: Model.getSize(value),
    onChange: onValueChange
  })), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowS",
    align: "center",
    className: S.weight
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "input"
  }, "Weight"), /*#__PURE__*/React.createElement(Flex.Layout, {
    grow: 1
  }, /*#__PURE__*/React.createElement(Selector, {
    eventData: "setWeight",
    value: Model.getWeight(value),
    values: [{
      value: null,
      name: 'Not Set'
    }, {
      value: 'bold',
      name: 'Bold'
    }, {
      value: 'bolder',
      name: 'Bolder'
    }, {
      value: 'normal',
      name: 'Normal'
    }, {
      value: 'light',
      name: 'Light'
    }],
    onChange: onValueChange
  }))), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowS",
    align: "center",
    className: S.style
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "input"
  }, "Style"), /*#__PURE__*/React.createElement(Flex.Layout, {
    grow: 1
  }, /*#__PURE__*/React.createElement(Selector, {
    eventData: "setStyle",
    value: Model.getStyle(value),
    values: [{
      value: null,
      name: 'Not set'
    }, {
      value: 'normal',
      name: 'Normal'
    }, {
      value: 'italic',
      name: 'Italic'
    }, {
      value: 'oblique',
      name: 'Oblique'
    }],
    onChange: onValueChange
  }))));
}